import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter } from 'mdbreact';
import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBMask, MDBView } from 'mdbreact';
import { Form, Input, Button, Checkbox, message } from 'antd';
import Login from './Login';
import Axios from 'axios'
import { URL } from '../api';
import logo from './img/logokpru.png'

import Swal from 'sweetalert2'

export default class Home extends Component {
    
    //    state = {
    //       Username: "",
    //       Password: "",
    //       loading: true,
    //       login_error: true,
    //       login_error2: true,
    //       login_error3: true,
    //     }

        constructor(props) {
            super(props);
            this.state = {
                value: '',
                Psaaword:'',
                modal: false,
                collapse: false,
                isWideEnough: false,
            };
            this.handleChange = this.handleChange.bind(this);
            this.handleChange2 = this.handleChange2.bind(this);
            this.handleSubmit = this.handleSubmit.bind(this);
            this.toggle = this.toggle.bind(this);
            this.onClick = this.onClick.bind(this);
          }

          onClick() {
            this.setState({
              collapse: !this.state.collapse,
            });
          }

          toggle = () => {
            this.setState({
              modal: !this.state.modal
            });
          }
        
          handleChange(event) {    this.setState({value: event.target.value});  }
          handleChange2(event) {    this.setState({Psaaword: event.target.value});  }

          handleSubmit(event) {
            // alert('A name was submitted: ' + this.state.value);
             event.preventDefault();

            const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
         datafrm.append("txtemail", this.state.value);
         datafrm.append("txtpass", this.state.Psaaword);

         
         const user = {
          "txtemail": this.state.value,
          "txtpass": this.state.Psaaword
        };

         fetch('https://mua.kpru.ac.th/FrontEnd_Mis/login/login/', {
          method: 'POST',
          body: JSON.stringify(user),
          headers: {
        
          }
        })
          .then(res => res.json())
          .then((res) => {
              console.log(res);
              if (res[0].loginstatus === "1" ) {

           
                //  alert("เข้าสู่ระบบสำเร็จ")

                   localStorage.setItem('name', res[0].frist_name +"  "+ res[0].last_name);
      
                   message.success("เข้าสู่ระบบสำเร็จ")
                   localStorage.setItem('loginstatus', res[0].loginstatus);
                   localStorage.setItem('type2', res[0].employee_id);
                   localStorage.setItem('admin_type', 2);
                 
              //   window.location.href = '/components/administrator/reportall'
             // window.location.href = 'https://conference.kpru.ac.th/adminconference-sd/adminfaculty'
            //  window.location.href = 'https://e-student.kpru.ac.th/grade/adminfaculty'
              window.location.href = '/vaccinekpru/Stuall'
              }else{
                 // message.error("เข้าสู่ระบบไม่สำเร็จ")
                  


                 Swal.fire(
                  'ไม่สามารถเข้าถึงระบบได้',
                  'กรุณาลองอีกครั้ง',
                  'question'
                )
                //  window.location.href = '/'
              }
            
          })
          .catch(err => {
            console.log('request failed', err);
          })
         

          }
      
        //   handleSubmit(event) {
        //     // alert('A name was submitted: ' + this.state.value);
        //      event.preventDefault();
        //     const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
        //  datafrm.append("Username", this.state.value);
        //  datafrm.append("Psaaword", this.state.Psaaword);

        //  Axios
        //  // .post("https://admission.kpru.ac.th/refund/api/getdata/getuseradmin", { Username: this.form.name, Password: this.form.pass })
        //    .post("https://research.kpru.ac.th/culture/apiculture/selectadmin.php",datafrm)
        //    .then(res => {
        //      console.log("response: ", res)
        //      if (res.data.length !== 0) {
        //       // this.showitem = true;
        //        console.log(res)
        //        console.log(res.data.length)

        //        if (res.data[0].register_status === "1") {

        //         return this.setState({
        //           loading: true,
        //           // token_exp: +decodedEXP + "000"  //เก็บค่าหมดอายุของ token มาไว้ในตัวแปร
        //         }),
        //           //   localStorage.setItem('tokenExp', decodedEXP + "000"),
        //           localStorage.setItem('nameuser', res.data[0].register_nameth + ' ' + res.data[0].register_lnameth),
        //           localStorage.setItem('admin_type', res.data[0].register_status),
        //           //   localStorage.setItem('profile', JSON.stringify(res.data[0]))
        //          // window.location.href = 'https://research.kpru.ac.th/culture/'
        //           window.location.href = '/adminfaculty'
    
        //       }
        //       else if (res.data[0].register_status === "2") {
        //         return this.setState({
        //           login_error3: true,
        //           // picuser: data.picture,
        //         }),
    
        //           localStorage.setItem('nameuser', res.data[0].Name),
        //           localStorage.setItem('admin_type', res.data[0].register_status),
    
        //           // localStorage.setItem('picuser', data[0].picture);

        //           // window.location.href = 'https://research.kpru.ac.th/culture/superadmin'
        //           window.location.href = '/Timetable'


        //         //  this.props.history.replace({ pathname: '/Reportbanner' })
        //       }
        //       else if (res.data[0].register_status === "3") {
        //         return this.setState({
        //           login_error3: true,
        //           // picuser: data.picture,
        //         }),
    
        //           localStorage.setItem('nameuser', res.data[0].register_nameth + ' ' + res.data[0].register_lnameth),
        //           localStorage.setItem('admin_type', res.data[0].register_status),
        //           localStorage.setItem('expert_id', res.data[0].id)
    
        //           // localStorage.setItem('picuser', data[0].picture);

        //          // window.location.href = 'https://conference.kpru.ac.th/adminconference-sd/expert'
        //          // window.location.href = '/expert'


        //         //  this.props.history.replace({ pathname: '/Reportbanner' })
        //       }  else if (res.data[0].register_status === "4") {
        //         return this.setState({
        //           login_error3: true,
        //           // picuser: data.picture,
        //         }),
    
        //           localStorage.setItem('nameuser', res.data[0].register_nameth + ' ' + res.data[0].register_lnameth),
        //           localStorage.setItem('admin_type', res.data[0].register_status),
        //           localStorage.setItem('admin_faculty', res.data[0].register_faculty)
    
        //         // localStorage.setItem('picuser', data[0].picture);

        //         //  window.location.href = 'https://conference.kpru.ac.th/adminconference-sd/adminfaculty'
        //         // window.location.href = '/adminfaculty'
        //         //  this.props.history.replace({ pathname: '/Reportbanner' })
        //       }

        //      }else{
        //       this.setState({
        //         modal: true
               
        //     })
        //       // window.location.href = '/'
        //       // window.location.href = '/'
        //      }
        //      // do something about response
        //    })

        //   }


          // handleSubmit(event) {
          //   console.log(this.state.value)
          //   if (this.state.value === '1620600091565') {

           
          //     //  alert("เข้าสู่ระบบสำเร็จ")

          //       // localStorage.setItem('name', res[0].frist_name +"  "+ res[0].last_name);
    
          //        message.success("เข้าสู่ระบบสำเร็จ")
          //        localStorage.setItem('nameuser', 'ชุลีพร')
          //        localStorage.setItem('admin_type', 4)
          //      //  localStorage.setItem('loginstatus', res[0].loginstatus);
          //     //   localStorage.setItem('type2', res[0].employee_id);
               
          //   //   window.location.href = '/components/administrator/reportall'
          //  // window.location.href = 'https://conference.kpru.ac.th/adminconference-sd/adminfaculty'
          //   window.location.href = '/tess/adminfaculty'
          //   }else{
          //      // message.error("เข้าสู่ระบบไม่สำเร็จ")
          //      Swal.fire(
          //       'ไม่สามารถเข้าถึงระบบได้',
          //       'กรุณาลองอีกครั้ง',
          //       'question'
          //     )
          //     //  window.location.href = '/'
          //   }


          // }



    update = () => {
        this.setState({
            name: "",
            lname: ""
        })
    }

    render() {
      
        return (
       
                <MDBContainer>
           
                    <MDBRow >
                    <MDBCol md="4">
                    </MDBCol>
                        <MDBCol md="4">
                            <div>
                            {/* <img src="https://research.kpru.ac.th/culture/LogoRDI.png" className="rounded mx-auto d-block w-50" alt="aligment" /><br/> */}
                            <img src={logo} className="rounded mx-auto d-block w-10 " alt="aligment" /><br/>
                          
                        <form onSubmit={this.handleSubmit}>
                            <p className="h3 text-center ">เข้าสู่ระบบ</p>
                            <p className="h5 text-center ">ตรวจสอบการฉีดวัคซีนของนักศึกษา</p>
                            <p className="h5 text-center ">(สำหรับอาจารย์)</p>
                            {/* <p className="h5 text-center "> ฝ่ายหลักสูตรและแผนการเรียน</p> */}
                            <div className="grey-text">
                            <MDBInput label="Username (เลขบัตรประจำตัวประชาชน)" icon="user" group type="text" validate error="wrong"
                                success="right"  name="Username" value={this.state.value} onChange={this.handleChange}/>

                            <MDBInput label="Password (ว/ด/ป เกิด)" icon="key" group type="password" validate error="wrong"
                                success="right" value={this.state.Psaaword} onChange={this.handleChange2} />

                            </div>
                            <div className="text-center">
                            <MDBBtn  color="blue darken-4" dark type="submit" value="Submit" >
                             เข้าสู่ระบบ
                                {/* <MDBIcon far icon="paper-plane" className="ml-1" /> */}
                                <MDBIcon icon="hand-point-up" className="ml-1" />
                            </MDBBtn>
                            </div>
                        </form>
                          {/* <Login/> */}
                           {/* {this.state.value}
                           {this.state.Psaaword} */}
                        </div>
                        </MDBCol>
                        <MDBCol md="4">
                    </MDBCol>
                    </MDBRow>

                    <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
        <MDBModalHeader toggle={this.toggle}>
        </MDBModalHeader>
        <MDBModalBody className="text-center">
         
        <MDBIcon icon="exclamation-circle" className="red-text text-center" size="5x" />
         <h3>usermame หรือ password ไม่ถูกต้อง</h3>
         <h3>กรุณาตรวจสอบความถูกต้อง อีกครั้ง!</h3>
        </MDBModalBody>
       
      </MDBModal>
                   
                    </MDBContainer>
                   
     
        )
    }
}
